var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarReferrals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3894 3H4.61094C2.33933 3 1.1554 5.63548 2.6962 7.26234L5.78568 10.5244C6.23 10.9935 6.47673 11.6086 6.47673 12.247V18.4553C6.47673 20.8735 9.61615 21.9233 11.1394 20.0145L21.4463 7.09894C22.7775 5.43071 21.5578 3 19.3894 3Z",
    stroke: "current",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarReferrals);
export default __webpack_public_path__ + "static/media/sidebar-referrals.66b5ab622ec9e35a2a9cb3109ddecfbb.svg";
export { ForwardRef as ReactComponent };